import { DonHangMua, DonHangMuaChiTiet, KeHoachNCCGiaoHang, ListFileModel, FileImport } from '../don-hang-mua-page-model/don-hang-mua.model';
import { NgbTimeStringAdapter } from 'dps-lib';
import { NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { select } from '@ngrx/store';
import {
  Component,
  OnInit,
  ElementRef,
  ViewChildren,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
  HostListener,
  Input
}
  from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { KhachHangService } from '../../../danh-muc/khach-hang/khach-hang-service/khach-hang.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonConFig, NhaCungCapModelLite } from '../../../dung-chung/__model/common_config.model';
import { SelectionModel } from '@angular/cdk/collections';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import moment from 'moment';
import { DonHangMuaDataSource } from '../don-hang-mua-page-datasource/don-hang-mua.datasource';
import { DonHangMuaService } from '../don-hang-mua-page-service/don-hang-mua.service';
import { LichSuGiaoHang } from '../don-hang-mua-page-model/don-hang-mua.model';
import { environment } from '../../../../../../../environments/environment';
import { LichSuGiaMuaHangComponent } from '../lich-su-gia-mua-hang/lich-su-gia-mua-hang.component';
import { KeHoachNCCGiaoHangComponent } from '../ke-hoach-ncc-giao-hang/ke-hoach-ncc-giao-hang.component';

@Component({
  selector: 'kt-duyet-don-hang-mua',
  templateUrl: './duyet-don-hang-mua.component.html',
  styleUrls: ['../don-hang-mua-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter }]
})

export class DuyetDonHangMuaComponent implements OnInit {
  /*Config Form */
  CONFIG: CommonConFig;
  dataSource: DonHangMuaDataSource;

  /* Trigger menu hiển thị cột cho danh sách */
  @ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;

  /* Loading.... */
  loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  viewLoading = false;
  /* ------------------------------------------------------------------ */

  //#region Phím tắt
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode) {
      this.back();
    }
  }
  //#endregion Phím tắt

  minDate = new Date();

  isShow: false;

  displayedColumns = [];
  availableColumns = [
    {
      stt: 1,
      name: '#',
      displayName: '#',
      alwaysChecked: false,
      isShow: true,
      type: 'number'
    },
    {
      stt: 2,
      name: 'SLGiao',
      displayName: 'SL Giao',
      alwaysChecked: false,
      isShow: true,
      type: 'number'
    },
    {
      stt: 3,
      name: 'NgayGiao',
      displayName: 'Ngày Giao',
      alwaysChecked: false,
      isShow: true,
      type: 'datetime'
    },
    {
      stt: 4,
      name: 'GioTu',
      displayName: 'Giờ từ',
      alwaysChecked: false,
      isShow: true,
      type: 'time'
    },
    {
      stt: 5,
      name: 'GioDen',
      displayName: 'Đến',
      alwaysChecked: false,
      isShow: true,
      type: 'time'
    },
    {
      stt: 5,
      name: 'ThaoTac',
      displayName: '',
      alwaysChecked: false,
      isShow: true,
      type: 'date'
    }
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('sort1', { static: true }) sort: MatSort;

  displayedColumnsFile = ["STT", "File", "GhiChu"];

  listFileDinhKem: ListFileModel[] = [];

  //filter on grid
  haveFilter: boolean = false;
  filterGroupDataChecked: any = {};
  filterGroupDataCheckedFake: any = {};
  filterGroupData: any = {};
  preFilterGroupData: any = {};
  filterGroupArray: any = {};
  filterText: any = {};
  tmpfilterText: any = {};
  disableButtonFilter: any = {};
  isClearAll: boolean = false;

  @Input() title: string = "THÔNG TIN DUYỆT MUA HÀNG";
  @Input() subTitle: string = "";

  SLMua: number = 0;

  DonHangMuaResult = [];
  tmpDonHangMuaResult = [];

  DuyetDonHangMuaForm: FormGroup;
  selectedColumns = new SelectionModel<any>(true, this.availableColumns);
  selection = new SelectionModel<any>(true, []);

  ELEMENT_DATA: DonHangMuaChiTiet;
  MASTER_DATA: DonHangMua;

  openFormDialog = false;

  IsDuyet: boolean = true;

  LIST_ROLES_USER: [] = [];
  XEM_HD = "06004";
  SHOW_VIEW_CONTRACT = new BehaviorSubject<boolean>(false);
  flagCMD = false;
  constructor(
    public dialogRef2: MatDialogRef<DuyetDonHangMuaComponent>,
    public dialog2: MatDialog,
    private changeDetect: ChangeDetectorRef,
    private service: DonHangMuaService,
    private layoutUtilsService: LayoutUtilsService,
    private formFB: FormBuilder,
    private el: ElementRef,
    private tokenStorage: TokenStorage,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.dialogRef2.disableClose = true;
    let user = JSON.parse(localStorage.getItem("UserInfo"));
    this.LIST_ROLES_USER = user.roles;
  }

  //#region Load Data
  async ngOnInit() {
    this.SHOW_VIEW_CONTRACT.next(this.isTrueButton(this.XEM_HD));

    /*Load cấu hình config form */
    this.CONFIG = new CommonConFig();
    this.subTitle = this.data.Ma_Ten_HH;
    this.ELEMENT_DATA = this.data.Detail;
    this.MASTER_DATA = this.data.Master;
    this.IsDuyet = this.data.IsDuyet;
    this.createForm();
    this.getChiTietDuyet(this.ELEMENT_DATA.Id);
    this.applySelectedColumns();
    this.changeDetect.detectChanges();
  }

  getChiTietDuyet(IdCt: number) {
    this.service.getChiTietDuyetDonHangMua(IdCt).subscribe(res => {
      if (res && res.status == 1) {
        var confirm = res.data.Confirm;
        if (confirm != null) {
          if (confirm.KQ_TPDuyet) {
            this.DuyetDonHangMuaForm.controls['TP_NGAYDUYET'].setValue(confirm.Date_TPDuyet);
            this.DuyetDonHangMuaForm.controls['TP_NGUOIDUYET'].setValue(confirm.Name_TPDuyet);
            this.DuyetDonHangMuaForm.controls['TP_KETQUADUYET'].setValue(confirm.KQ_TPDuyet);
            this.DuyetDonHangMuaForm.controls['TP_LYDO'].setValue(confirm.LyDo_TPDuyet);
            this.flagCMD = true;
          }
          if (confirm.KQ_GDKTMDuyet) {
            this.DuyetDonHangMuaForm.controls['GDKTM_NGAYDUYET'].setValue(confirm.Date_GDKTMDuyet);
            this.DuyetDonHangMuaForm.controls['GDKTM_NGUOIDUYET'].setValue(confirm.Name_GDKTMDuyet);
            this.DuyetDonHangMuaForm.controls['GDKTM_KETQUADUYET'].setValue(confirm.KQ_GDKTMDuyet);
            this.DuyetDonHangMuaForm.controls['GDKTM_LYDO'].setValue(confirm.LyDo_GDKTMDuyet);
          }
          if (confirm.KQ_GDKDuyet) {
            this.DuyetDonHangMuaForm.controls['GDK_NGAYDUYET'].setValue(confirm.Date_GDKDuyet);
            this.DuyetDonHangMuaForm.controls['GDK_NGUOIDUYET'].setValue(confirm.Name_GDKDuyet);
            this.DuyetDonHangMuaForm.controls['GDK_KETQUADUYET'].setValue(confirm.KQ_GDKDuyet);
            this.DuyetDonHangMuaForm.controls['GDK_LYDO'].setValue(confirm.LyDo_GDKDuyet);
          }
          if (confirm.KQ_GDDuyet) {
            this.DuyetDonHangMuaForm.controls['GD_NGAYDUYET'].setValue(confirm.Date_GDDuyet);
            this.DuyetDonHangMuaForm.controls['GD_NGUOIDUYET'].setValue(confirm.Name_GDDuyet);
            this.DuyetDonHangMuaForm.controls['GD_KETQUADUYET'].setValue(confirm.KQ_GDDuyet);
            this.DuyetDonHangMuaForm.controls['GD_LYDO'].setValue(confirm.LyDo_GDDuyet);
          }
        }
      } else {
        this.layoutUtilsService.showErorr("Lấy chi tiết duyệt phiếu thất bại");
      }
    });
  }

  isTrueButton(ROLENUMBER: string) {
    if (this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) {
      return true;
    }
    return false;
  }


  createForm() {
    // Form 1
    var item = this.ELEMENT_DATA;
    var master = this.MASTER_DATA;
    this.DuyetDonHangMuaForm = this.formFB.group({
      MaNCC: [master.MaNCC],
      TenNCC: [master.TenNCC],
      NgayCan: [master.NgayDat],
      MaHH: [item.MaHH],
      TenHH: [item.TenHH],
      QuyCach: [item.QuyCach],
      DVT: [item.TenDVT],
      SoPhieuDNMH: [item.SoPhieuDNMH],
      GhiChu: [item.GhiChu],
      SoLuong: [item.SoLuong],
      DonGia: [item.DonGia],
      ThanhTien: [item.ThanhTien],
      ThanhTienQuyDoi: [item.ThanhTienQuyDoi],
      PTThue: [item.PhanTramThue],
      Thue: [item.TienThue],
      TrangThaiMHForm: [item.TrangThaiMH],
      PhongBanSuDungForm: [item.PhongBanSuDung],
      HopDong: [this.data.TenHD],
      TP_NGAYDUYET: [],
      TP_NGUOIDUYET: [""],
      TP_KETQUADUYET: [],
      TP_LYDO: [],
      GDKTM_NGUOIDUYET: [""],
      GDKTM_NGAYDUYET: [],
      GDKTM_KETQUADUYET: [],
      GDKTM_LYDO: [],
      GDK_NGUOIDUYET: [""],
      GDK_NGAYDUYET: [],
      GDK_KETQUADUYET: [],
      GDK_LYDO: [],
      GD_NGUOIDUYET: [""],
      GD_NGAYDUYET: [],
      GD_KETQUADUYET: [],
      GD_LYDO: [],
    });

    this.DuyetDonHangMuaForm.controls['MaNCC'].disable();
    this.DuyetDonHangMuaForm.controls['MaHH'].disable();
    this.DuyetDonHangMuaForm.controls['TenHH'].disable();
    this.DuyetDonHangMuaForm.controls['TenNCC'].disable();
    this.DuyetDonHangMuaForm.controls['NgayCan'].disable();
    this.DuyetDonHangMuaForm.controls['SoPhieuDNMH'].disable();
    this.DuyetDonHangMuaForm.controls['QuyCach'].disable();
    this.DuyetDonHangMuaForm.controls['DVT'].disable();
    this.DuyetDonHangMuaForm.controls['GhiChu'].disable();
    this.DuyetDonHangMuaForm.controls['SoLuong'].disable();
    this.DuyetDonHangMuaForm.controls['DonGia'].disable();
    this.DuyetDonHangMuaForm.controls['ThanhTien'].disable();
    this.DuyetDonHangMuaForm.controls['ThanhTienQuyDoi'].disable();
    this.DuyetDonHangMuaForm.controls['PTThue'].disable();
    this.DuyetDonHangMuaForm.controls['Thue'].disable();
    this.DuyetDonHangMuaForm.controls['HopDong'].disable();
    this.DuyetDonHangMuaForm.controls['PhongBanSuDungForm'].disable();
    this.DuyetDonHangMuaForm.controls['TrangThaiMHForm'].disable();
    this.DuyetDonHangMuaForm.controls['TP_NGAYDUYET'].disable();
    this.DuyetDonHangMuaForm.controls['TP_NGUOIDUYET'].disable();
    this.DuyetDonHangMuaForm.controls['GDKTM_NGAYDUYET'].disable();
    this.DuyetDonHangMuaForm.controls['GDKTM_NGUOIDUYET'].disable();
    this.DuyetDonHangMuaForm.controls['GDK_NGAYDUYET'].disable();
    this.DuyetDonHangMuaForm.controls['GDK_NGUOIDUYET'].disable();
    this.DuyetDonHangMuaForm.controls['GD_NGAYDUYET'].disable();
    this.DuyetDonHangMuaForm.controls['GD_NGUOIDUYET'].disable();

    var tenNguoiLap = '';
    this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

    if (this.ELEMENT_DATA.TrangThaiMH != 1 || !this.IsDuyet) {
      this.DuyetDonHangMuaForm.controls['TP_KETQUADUYET'].disable();
      this.DuyetDonHangMuaForm.controls['TP_LYDO'].disable();
    } else {
      this.DuyetDonHangMuaForm.controls['TP_NGAYDUYET'].setValue(new Date());
      this.DuyetDonHangMuaForm.controls['TP_NGUOIDUYET'].setValue(tenNguoiLap);
      this.DuyetDonHangMuaForm.controls['TP_KETQUADUYET'].setValue("DHM_DUYET_CT");
    }
    if (this.ELEMENT_DATA.TrangThaiMH != 2 || !this.IsDuyet) {
      this.DuyetDonHangMuaForm.controls['GDK_KETQUADUYET'].disable();
      this.DuyetDonHangMuaForm.controls['GDK_LYDO'].disable();
    } else {
      this.DuyetDonHangMuaForm.controls['GDK_NGAYDUYET'].setValue(new Date());
      this.DuyetDonHangMuaForm.controls['GDK_NGUOIDUYET'].setValue(tenNguoiLap);
      this.DuyetDonHangMuaForm.controls['GDK_KETQUADUYET'].setValue("DHM_DUYET_CT");
    }
    if (this.ELEMENT_DATA.TrangThaiMH != 3 || !this.IsDuyet) {
      this.DuyetDonHangMuaForm.controls['GD_KETQUADUYET'].disable();
      this.DuyetDonHangMuaForm.controls['GD_LYDO'].disable();
    } else {
      this.DuyetDonHangMuaForm.controls['GD_NGAYDUYET'].setValue(new Date());
      this.DuyetDonHangMuaForm.controls['GD_NGUOIDUYET'].setValue(tenNguoiLap);
      this.DuyetDonHangMuaForm.controls['GD_KETQUADUYET'].setValue("DHM_DUYET_CT");
    }
    if (this.ELEMENT_DATA.TrangThaiMH != 7 || !this.IsDuyet) {
      this.DuyetDonHangMuaForm.controls['GDKTM_KETQUADUYET'].disable();
      this.DuyetDonHangMuaForm.controls['GDKTM_LYDO'].disable();
    } else {
      this.DuyetDonHangMuaForm.controls['GDKTM_NGAYDUYET'].setValue(new Date());
      this.DuyetDonHangMuaForm.controls['GDKTM_NGUOIDUYET'].setValue(tenNguoiLap);
      this.DuyetDonHangMuaForm.controls['GDKTM_KETQUADUYET'].setValue("DHM_DUYET_CT");
    }
  }

  addHang() {

    const controls = this.DuyetDonHangMuaForm.controls;
    /** check form */
    if (this.DuyetDonHangMuaForm.invalid) {
      const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
      //let indexList = [];
      if (invalidElements.length > 0) {
        for (let i = 0; i < invalidElements.length; i++) {
          if (invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT') {
            const elementControl = this.DuyetDonHangMuaForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
            if (elementControl) {
              setTimeout(() => invalidElements[i].focus(), 100);
              break;
            }
          }
        }
      }
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }



    var SLDaThem: number = 0;
    this.tmpDonHangMuaResult.forEach(x => { SLDaThem += Number(x.SoLuong) });
    SLDaThem += Number(this.f_number(controls['SLGIAO'].value));
    if (SLDaThem > this.SLMua) {
      this.layoutUtilsService.showErorr("Tổng số lượng kế hoạch ncc giao hàng vượt số lượng đơn hàng đã mua!");
      return;
    }

    var isFail = false;

    if (this.tmpDonHangMuaResult.length > 0) {
      this.tmpDonHangMuaResult.forEach(x => {
        if (x.SoLuong == Number(this.f_number(controls['SLGIAO'].value))
          && moment(x.NgayVe).format("DD/MM/YYYY").toString() == moment(controls['NGAYGIAO'].value).format("DD/MM/YYYY").toString()
          && moment(this.tmpDonHangMuaResult[0].GioVe).format("HH:mm").toString() == controls['GIOTU'].value
          && moment(this.tmpDonHangMuaResult[0].GioDen).format("HH:mm").toString() == controls['GIODEN'].value
        ) {
          isFail = true;
        }
      });
    }

    if (isFail) {
      this.layoutUtilsService.showErorr("Giá trị đã tồn tại trong danh sách, vui lòng kiểm tra lại!");
      return;
    }



    var item = new KeHoachNCCGiaoHang();
    item.clear();
    item.HangHoa_Id = this.ELEMENT_DATA.IdHH;
    item.SoLuong = Number(this.f_number(controls['SLGIAO'].value));

    var time = moment(controls['NGAYGIAO'].value).toDate();
    time.setHours(0);
    time.setMinutes(0);
    time.setSeconds(0);
    item.NgayVe = moment(time).format('YYYY-MM-DD[T]HH:mm:ss');

    var [hVe, mVe] = controls['GIOTU'].value.toString().split(":").map(Number);
    time.setHours(hVe);
    time.setMinutes(mVe);
    time.setSeconds(0);
    item.GioVe = moment(time).format('YYYY-MM-DD[T]HH:mm:ss');

    var [hDen, mDen] = controls['GIODEN'].value.toString().split(":").map(Number);
    time.setHours(hDen);
    time.setMinutes(mDen);
    time.setSeconds(0);
    item.GioDen = moment(time).format('YYYY-MM-DD[T]HH:mm:ss');

    item.DVT = this.ELEMENT_DATA.IdDVT;

    this.tmpDonHangMuaResult.push(item);
    this.tmpDonHangMuaResult.sort(function (a, b) {
      var dateA = new Date(a.NgayVe.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/, "$2$1$3"));
      var dateB = new Date(b.NgayVe.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/, "$2$1$3"));
      if ((dateA.getTime() - dateB.getTime()) == 0) {
        if (a.GioVe == b.GioVe) {
          return (a.GioDen < b.GioDen) ? -1 : 1;
        } else return (a.GioVe < b.GioVe) ? -1 : 1;
      } else return dateA.getTime() - dateB.getTime();
    });



    this.tmpDonHangMuaResult = [...this.tmpDonHangMuaResult];

    this.DuyetDonHangMuaForm.reset();

    controls['SLGIAO'].setValue('0,00');
    controls['NGAYGIAO'].setValue(new Date());
    controls['GIOTU'].setValue("06:00");
    controls['GIODEN'].setValue("12:00");

    this.changeDetect.detectChanges();
  }

  deleteHang(index: number) {
    this.tmpDonHangMuaResult.splice(index, 1);
    this.tmpDonHangMuaResult = [...this.tmpDonHangMuaResult];
    this.changeDetect.detectChanges();
  }

  stringToTime(data: string) {
    return moment(data, "HH:mm");
  }

  filterConfiguration(): any {
    const filter: any = {};
    return filter;
  }

  ngAfterViewInit() {
    this.changeDetect.detectChanges();
  }
  //#endregion Load Data

  //#region Quay về
  back() {
    this.dialogRef2.close({
      data: this.ELEMENT_DATA
    });
  }
  //#endregion Quay về

  applySelectedColumns() {
    let _selectedColumns = this.selectedColumns.selected;
    this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
    for (let i = 0; i < this.availableColumns.length; i++) {
      this.selectedColumns.toggle(this.availableColumns[i]);
      for (let j = 0; j < _selectedColumns.length; j++) {
        if (this.availableColumns[i].name == _selectedColumns[j].name) {
          this.selectedColumns.toggle(this.availableColumns[i]);
          break;
        }
      }
    }
    const _applySelectedColumns: string[] = [];
    this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
    this.displayedColumns = _applySelectedColumns;
  }

  getFormatDate(v: string = '') {
    if (v != '') {
      return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
    }
    return '';
  }

  f_number(item: any = "0.00") {
    return FunctionPublic.F_NUMBER(item);
  }

  fomartData(data: any, type: string) {
    switch (type) {
      case 'number': return this.f_number(data);
      case 'string': return data;
      case 'date': return this.getFormatDate(data);
      case 'time': return moment(data).format("HH:mm");
      default: return data;
    }
  }

  checkTimeFromAndTo() {
    const [hFrom, mFrom] = (this.DuyetDonHangMuaForm.controls['GIOTU'].value ? this.DuyetDonHangMuaForm.controls['GIOTU'].value.toString() : "00:00").split(":").map(Number);
    const [hTo, mTo] = (this.DuyetDonHangMuaForm.controls['GIODEN'].value ? this.DuyetDonHangMuaForm.controls['GIODEN'].value.toString() : "00:00").split(":").map(Number);
    if (hFrom > hTo) return true;
    if (hFrom == hTo && mFrom > mTo) return true;
    return false;
  }

  keyUpInputNumberVND(event) {
    FunctionPublic.preventAlphaV2(event);
  }

  changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
    let controls = formGroup.controls;
    let position = event.target.selectionStart;
    let sizeStart = event.target.value.toString().length;
    let sizeEnd = sizeStart;
    var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
    var found = event.target.value.match(regex);
    if (found != null) {
      event.preventDefault();
    }
    else {
      if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

      let data = FunctionPublic.slListChangedV2(event);
      if (data) {
        if (this.f_number(data) <= min && event.data && event.data == '0') data = this.f_number(min);
        controls[columnName].setValue(data);
        sizeEnd = data.toString().length;
        let balance = sizeEnd - sizeStart;
        event.target.selectionStart = position + balance;
        event.target.selectionEnd = position + balance;

        if (data.length == 4) {
          event.target.selectionStart = position;
          event.target.selectionEnd = position;
        }

      } else {
        controls[columnName].setValue(this.f_number(min));
        event.target.selectionStart = 0;
        event.target.selectionEnd = 0;
      }

    }
  }

  changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
    let controls = formGroup.controls;
    if (this.ValidateChangeNumberForm(event)) {
      let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

      if (isNaN(tmpValue)) tmpValue = min;

      if (Number(tmpValue) < min) tmpValue = min;

      if (!controls[controlName].invalid) {
        controls[controlName].setValue(
          this.f_number(tmpValue)
        );
      }

      controls[controlName].setValue(
        this.f_number(tmpValue)
      );
    }
    else {
      controls[controlName].setValue(this.f_number(min.toString()));
    }

    this.changeDetect.detectChanges();

  }

  ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
    var count = 0;
    let data: string = '';
    if (isEvent) {
      for (let i = 0; i < event.target.value.length; i++) {
        if (event.target.value[i] == ',') {
          count += 1;
        }
      }
      data = event.target.value;
    }
    else {
      for (let i = 0; i < event.length; i++) {
        if (event[i] == ',') {
          count += 1;
        }
      }
      data = event;
    }
    var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
    var found = isEvent ? event.target.value.match(regex) : String(event).match(regex);
    if (found != null) {
      return false;;
    }
    if (count >= 2) {
      return false;;
    }
    return true;
  }

  luuKeHoachNCCGiaoHang() {
    if (this.tmpDonHangMuaResult.length == 0) {
      this.layoutUtilsService.showErorr("Vui lòng thêm kế hoạch ncc giao hàng vào danh sách");
      return false;
    }

    this.ELEMENT_DATA.KeHoachNCCGiaoHang = [];
    this.ELEMENT_DATA.KeHoachNCCGiaoHang = this.tmpDonHangMuaResult;

    this.back();
  }

  showPhanTramThue(value: any) {
    value += "";
    switch (value) {
      case "0": return "Không thuế";
      case "1": return "0";
      case "2": return "5";
      case "3": return "10";
    }
  }

  getNameTrangThaiMatHang(t: number) {
    switch (t) {
      case 0: {
        return "Đang soạn thảo";
      }
      case 1: {
        return "Chờ TP duyệt";
      }
      case 2: {
        return "Chờ GĐ Khối duyệt";
      }
      case 3: {
        return "Chờ GĐ duyệt";
      }
      case 4: {
        return "Chờ đóng PO";
      }
      case 5: {
        return "Không duyệt";
      }
      case 6: {
        return "Hoàn tất";
      }
    }
  }

  downloadFile(i: number, item: FileImport, IsFileDinhKem: number = 1) {
    if (item.idLoaiHH > 0) {
      this.service.downloadTemplate(item.idLoaiHH).subscribe(blob => {
        var downloadLink = document.createElement("a");
        var url = URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = item.filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });
    } else {
      let objectURL;
      console.log(item);
      const file = item.fileByte;
      objectURL = URL.createObjectURL(file);
      var downloadLink = document.createElement("a");
      downloadLink.href = objectURL;
      downloadLink.download = item.filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }

  xemKeHoachNCCGiao() {
    this.openFormDialog = true;
    const dialogRef = this.dialog2.open(KeHoachNCCGiaoHangComponent, {
      data: {
        data: this.ELEMENT_DATA,
        dangsoanthao: false,
        nguoilapphieu: this.isCreate(),
        isThaoTac: false
      },
      maxHeight: '90vh',
      width: '85vw'
    });

    dialogRef.afterClosed().subscribe(res => {
      this.openFormDialog = true;
      setTimeout(() => {
        this.openFormDialog = false;
      }, 50);
    });
  }

  xemLichSuGiaMuaHang() {
    this.openFormDialog = true;
    const dialogRef = this.dialog2.open(LichSuGiaMuaHangComponent, {
      data: {
        IdHH: this.ELEMENT_DATA.IdHH,
        Ma_Ten_HH: this.ELEMENT_DATA.MaHH + " - " + this.ELEMENT_DATA.TenHH
      },
      maxHeight: '90vh',
      width: '90vw'
    });

    dialogRef.afterClosed().subscribe(res => {
      this.openFormDialog = true;
      setTimeout(() => {
        this.openFormDialog = false;
      }, 50);
    });
  }

  isCreate() {
    var idUser = '';
    this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
    if (this.MASTER_DATA.NguoiTao == +idUser) {
      return true;
    }
    return false;
  }

  changeKetQuaDuyet(event: any, level: number) {

    if (event.value == "DHM_KHONGDUYET_CT") {
      if (level == 1) {
        this.DuyetDonHangMuaForm.controls['TP_LYDO'].setValidators([Validators.required]);
        this.DuyetDonHangMuaForm.controls['TP_LYDO'].updateValueAndValidity();
      }
      if (level == 2) {
        this.DuyetDonHangMuaForm.controls['GDK_LYDO'].setValidators([Validators.required]);
        this.DuyetDonHangMuaForm.controls['GDK_LYDO'].updateValueAndValidity();
      }
      if (level == 3) {
        this.DuyetDonHangMuaForm.controls['GD_LYDO'].setValidators([Validators.required]);
        this.DuyetDonHangMuaForm.controls['GD_LYDO'].updateValueAndValidity();
      }
    } else {
      if (level == 1) {
        this.DuyetDonHangMuaForm.controls['TP_LYDO'].clearValidators();
        this.DuyetDonHangMuaForm.controls['TP_LYDO'].updateValueAndValidity();
      }
      if (level == 2) {
        this.DuyetDonHangMuaForm.controls['GDK_LYDO'].clearValidators();
        this.DuyetDonHangMuaForm.controls['GDK_LYDO'].updateValueAndValidity();
      }
      if (level == 3) {
        this.DuyetDonHangMuaForm.controls['GD_LYDO'].clearValidators();
        this.DuyetDonHangMuaForm.controls['GD_LYDO'].updateValueAndValidity();
      }
    }
    this.changeDetect.detectChanges();
  }

  LuuKQDuyet(level: number = 1) {
    var firstChar = "TP";
    switch (level) {
      case 1: firstChar = "TP"; break;
      case 2: firstChar = "GDK"; break;
      case 3: firstChar = "GD"; break;
      case 7: firstChar = "GDKTM"; break;
    }
    const ACCEPT: string = "DHM_DUYET_CT";
    const REJECT: string = "DHM_KHONGDUYET_CT";
    let IDs = [{
      PhieuDatHangCtId: this.ELEMENT_DATA.Id,
      NoiDung: this.DuyetDonHangMuaForm.controls[firstChar + '_LYDO'].value ? this.DuyetDonHangMuaForm.controls[firstChar + '_LYDO'].value : "",
      TrangThaiMH: this.ELEMENT_DATA.TrangThaiMH
    }];
    var data = {
      PhieuDatHangId: this.ELEMENT_DATA.IdPhieu,
      IDs: IDs,
      LoaiThaoTac: this.DuyetDonHangMuaForm.controls[firstChar + '_KETQUADUYET'].value,
    }
    if (data.LoaiThaoTac == REJECT) {
      if (IDs.filter(x => x.NoiDung == null || x.NoiDung.toString().trim().length == 0).length > 0) {
        this.layoutUtilsService.showErorr("Bạn chưa nhập lý do không duyệt");
        return false;
      }
    }
    const dialogRef = this.layoutUtilsService.POP02(this.MASTER_DATA.SoPhieu);
    dialogRef.afterClosed().subscribe(res => {
      if (!res) return;
      this.service.setChiTietDuyetDonHangMua(data).subscribe(res => {
        if (res && res.status == 1) {
          let rev = res.data ? res.data.IDs : [];
          let checked = rev.find(x => x.PhieuDatHangCtId == this.ELEMENT_DATA.Id);
          if (checked != null) this.ELEMENT_DATA.TrangThaiMH = checked.TrangThaiMH;
          this.back();
        } else {
          this.layoutUtilsService.showErorr(res.error.message);
        }
      });
    });
  }
}

